import React, { ReactElement } from "react";

import { SVGProps } from "react";
import { IconSvg } from "../../icon/icon-svg";

type IconInputApplyProps = SVGProps<SVGSVGElement> & {
  disabled?: boolean;
};

const disabledColor = "#aaa";

export const IconInputApply = ({
  disabled,
  ...svgAttrs
}: IconInputApplyProps): ReactElement => (
  <IconSvg {...svgAttrs}>
    <g clipPath="url(#clip0_1230_16330)" fill="transparent">
      <path
        d="M19.5889 8H2.7373"
        stroke="url(#paint0_linear_1230_16330)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.411133 15.5542L2.73748 7.99977L0.411133 0.445312L19.5891 7.99977L0.411133 15.5542Z"
        stroke="url(#paint1_linear_1230_16330)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1230_16330"
        x1="19.5889"
        y1="9"
        x2="17.1218"
        y2="2.52181"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={disabled ? disabledColor : "#CF0048"} />
        <stop offset="0.5" stopColor={disabled ? disabledColor : "#E50000"} />
        <stop offset="1" stopColor={disabled ? disabledColor : "#FF5437"} />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1230_16330"
        x1="19.5891"
        y1="15.5542"
        x2="-1.74268"
        y2="11.3352"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={disabled ? disabledColor : "#BD0041"} />
        <stop offset="0.5" stopColor={disabled ? disabledColor : "#E50000"} />
        <stop offset="1" stopColor={disabled ? disabledColor : "#FF4545"} />
      </linearGradient>
      <clipPath id="clip0_1230_16330">
        <rect
          width="20"
          height="15.9309"
          fill="white"
          transform="translate(0 0.0341797)"
        />
      </clipPath>
    </defs>
  </IconSvg>
);
